var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('center',[_c('clip-loader',{attrs:{"loading":true,"color":"#CCC","size":"10px"}}),_vm._v(" Loading Permissions ... ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }